var _defs, _path, _rect, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDentist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 131.01 227.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#e8e9e8;}.cls-3{fill:#9a9794;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#c695bd;}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:#b27baa;}.cls-8{fill:#301d49;}.cls-9{fill:#51bcbd;}.cls-10{fill:#b18a67;}.cls-10,.cls-11{fill-rule:evenodd;}.cls-11,.cls-15{fill:#3f2c55;}.cls-12{fill:#85cbcc;}.cls-13{fill:#221433;}.cls-14{fill:#b1dcdd;}.cls-16{fill:#402b56;}.cls-17{fill:#84cbcc;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-370.05 -460.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 374.82,
    y: 456.19,
    width: 126.24,
    height: 163.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-370.05 -460.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 374.82,
    y: 460.12,
    width: 108.35,
    height: 159.72
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M437.94,600.92a63.12,63.12,0,1,0-63.12-63.12,63.12,63.12,0,0,0,63.12,63.12",
    transform: "translate(-370.05 -460.12)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.06,
    y: 99.1,
    width: 12.41,
    height: 60.62
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M475.52,559.21v9.95q-6.21-.48-12.41-.9v-9Z",
    transform: "translate(-370.05 -460.12)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "79.63 99.09 79.63 107.74 67.22 107.37 67.22 99.09 79.63 99.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M427.7,687.41a115.18,115.18,0,0,1-19.65.28h-1.41c-1.13-8.12,1.87-10.83,2.08-11h0a4.66,4.66,0,0,0,1.61-2.46,12,12,0,0,0,.33-5.51c3.81-.24,8-.52,11.82-.39a33.68,33.68,0,0,1,5.21,19.11",
    transform: "translate(-370.05 -460.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M426.71,642.45c.51,15.47,1.55,29.25,1.55,29.25-9.73,3-22.26,0-22.26,0-.33-13.82-.19-27.76.15-40.28.4-14.54,1.06-27.18,1.57-35.53a16.49,16.49,0,0,1,10.43-14.32c9.71,7.12,12.1,18.58,12.1,18.58-4,1.15-4.18,23-3.54,42.3",
    transform: "translate(-370.05 -460.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M443.15,487.69c4.15-2.34,7.64-5.79,9-10.59,4-13.82-15.85-17.72-22-12.26s-12,22.86-7.76,25.81c1.71,1.17,4.82,2.46,9.8,1.5l-7.33,12.53,9-2.91.83,13.26,4.78-1.19Z",
    transform: "translate(-370.05 -460.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M439,474q-5.3,11.76-9,10.4c-3.73-1.37-6-4.89-7.65-5.49-1.19-.43-1.47,1.16-1.09,2.55.32,1.15,3.17,3.19,2.65,4.6s-2.62-.6-2.93.24c-.51,1.39-1.9,3.83.5,4.71s9.74,2.57,12.26-.61q2.44-3.08,6.81-13.94a3.47,3.47,0,0,1,.46.13,4,4,0,0,1,.27,7.45c.42,1.55.93,3.2,1.56,4.94,5.14-1,11-7.24,9.47-15.86a9.92,9.92,0,0,0-4.49-8.69,11.62,11.62,0,0,0-7-3.17c-4.37-1.19-8.63-1.28-10-.91-1.47,4-1.13,5.49,5.55,7.82A13,13,0,0,1,439,474",
    transform: "translate(-370.05 -460.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M395.88,687.41a115.18,115.18,0,0,1-19.65.28h-5.87c-.87-2,.23-5.06,1.59-6.77a28.77,28.77,0,0,1,4.94-4.25h0a4.64,4.64,0,0,0,1.61-2.47,11.8,11.8,0,0,0,.32-5.5c3.82-.24,8-.52,11.83-.39a33.68,33.68,0,0,1,5.21,19.11",
    transform: "translate(-370.05 -460.12)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M418.88,575.85a111.06,111.06,0,0,0-31.57,5.37,16.5,16.5,0,0,0-11.41,14.67c-.95,15.54-2.43,45.94-1.72,75.81,0,0,12.53,3,22.26,0,0,0-5.24-69.47,2-71.55,0,0,31.51,7.66,38.2.12Z",
    transform: "translate(-370.05 -460.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M470.88,627.5a1.76,1.76,0,0,0,2-1.88c-.55-7.64-2.38-33-2.38-34.84.85-17.12,1.26-34.85,2.12-52,.38-7.88.76-15.9-.1-23.7a17.29,17.29,0,0,0-13-14.85l-3-.73a60.22,60.22,0,0,0-28.62.13l-.23.05c-5.37,1.3-13.18,4.66-11.95,9.92,4.36,18.64,0,10.39,5,22.22,2.72,7.74,1.29,22.5-2.62,29.71-.9,1.65-1.87,3.27-2.87,4.87-.63,1-1.28,2-1.93,3s-1.41,2.19-2.1,3.28c-2,3.24-6.39,6-7.91,9.56-6,13.93-4.59,29.8-3.06,44.89,8.3,2.2,19.31,3,27.78,1.64,13.45-4.48,35.93-2.21,42.92-1.35",
    transform: "translate(-370.05 -460.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M406.33,611h0",
    transform: "translate(-370.05 -460.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M423.37,582.53l-1.66,2.94A30.87,30.87,0,0,1,410,573.74c.69-1.1,1.4-2.19,2.1-3.29a27.56,27.56,0,0,0,11.26,12.08",
    transform: "translate(-370.05 -460.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M464.39,679.12h-8.47V603.89h-7.55v75.23h-9.65a8.65,8.65,0,0,0-8.65,8.65h43a8.65,8.65,0,0,0-8.65-8.65",
    transform: "translate(-370.05 -460.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 75.76,
    y: 117.68,
    width: 12.53,
    height: 17.43
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M482.34,521a4.54,4.54,0,0,0-3.65-5.41c-6.58-1.15-18.58-3-25.66-2.9-7.08-.14-19.08,1.75-25.66,2.9a4.54,4.54,0,0,0-3.65,5.41,198,198,0,0,1,3.45,57.36,3.67,3.67,0,0,0,3.66,4h44.4a3.69,3.69,0,0,0,3.67-4A198,198,0,0,1,482.34,521",
    transform: "translate(-370.05 -460.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M483.17,600.49c0,3.66-1.18,7.69-4.36,9.51a9.75,9.75,0,0,1-6.5.8,45.06,45.06,0,0,1-6.37-2l-.14,0a44.66,44.66,0,0,0-28.49,0l-.14,0a45.18,45.18,0,0,1-6.38,2,9.73,9.73,0,0,1-6.49-.8c-3.18-1.82-4.41-5.85-4.36-9.51s1.47-7.89,4.84-9.53,7.59-.16,11.31,1a55.22,55.22,0,0,0,30.93,0c3.71-1.13,7.81-2.66,11.3-1s4.8,5.78,4.85,9.53",
    transform: "translate(-370.05 -460.12)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M406,509.37l7.7-8.87c8.9-4.54,12.58-9.6,11.52-10.64-1.58-1.56-3.46,2-4.46.75s.7-3.81.92-4.73-.12-1.7-.8-1.9-6.81-2.09-11,10.13L399,505Z",
    transform: "translate(-370.05 -460.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M422,524.6l-31.7,9.14-.43.13a7.9,7.9,0,0,1-8.46-12.4l19.87-25.92L412.86,504l-18.63,26.82-8.88-12.28,31.06-11.13Z",
    transform: "translate(-370.05 -460.12)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentist);
export default __webpack_public_path__ + "static/media/dentist.03f4ec69.svg";
export { ForwardRef as ReactComponent };